import { Capacitor } from "@capacitor/core";

// App Store rules: subscriptions can't be bought in the iOS app (no Razorpay there).
// Vendors on iOS can still see and use the subscriptions they already have.
export const isIOSApp = () => Capacitor.getPlatform() === "ios";

export const IOS_SUBSCRIPTION_NOTE = "Subscriptions can't be purchased in the iOS app. Please contact the Cars53 team to get or renew a subscription.";
